import BaseClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkCreateApi extends BaseClient {
  public doExternalLinkCreate (bodyData: any) {
    const path:string = '/v1/external-links'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new ExternalLinkCreateApi()
